import React from 'react'
import CommonServices from '../CommonComponent/CommonServices'
export default function Services() {

  return (
    <>
    <div className="serviceSpace"></div>
      <CommonServices/>
    </>
  )
}
